import { useIsAnyMobileState } from '@/stores/responsive.store';
import { memo } from 'react';
import { useUpdateTicketModal } from './use-update-ticket-modal';
import { Modal } from '@/components/_ui/modal';
import DekstopUpdateTicketForm from './desktop-update-ticket-form';
import MobileUpdateTicketForm from './mobile-update-ticket-form';
import { Spinner } from '@/components/_ui/spinner';
import TimeFrameModal from '@/components/ui/timeframe-modal';
import { ConfirmUnsavedChangesModal } from '../confirm-unsaved-changes-modal';

export type TUpdateTicketModalType = 'UpdateTicketModal';
export interface IUpdateTicketModalProps {
  spaceId: string;
  ticketId: string;
  spaceColumnId?: string;
  position?: string;
  isMarkAsCompleted?: boolean | null;
}

const UpdateTicketModal = memo(
  ({ spaceId, spaceColumnId, position, ticketId, isMarkAsCompleted }: IUpdateTicketModalProps) => {
    const isAnyMobile = useIsAnyMobileState();
    const updateTicketModalHookState = useUpdateTicketModal({
      spaceId,
      spaceColumnId,
      position,
      ticketId,
      isMarkAsCompleted,
    });

    

    if (updateTicketModalHookState.isLoadingSingleTicketQuery) {
      return (
        <Modal
          className={
            isAnyMobile ? 'p-0 w-[365px] h-fit overflow-hidden' : 'p-0 max-w-[1080px] w-full h-fit overflow-hidden'
          }
          isCloseOutside={false}
          isButtonClose={true}
          isOpen={updateTicketModalHookState.isUpdateTicketOpen}
          onClose={updateTicketModalHookState.handleCloseModal}
          lockBodyScroll
        >
          <div className={isAnyMobile ? 'h-[450px]' : 'h-[600px]'}>
            <div className="flex items-center justify-center w-full h-full">
              <Spinner className="w-[36px] h-[36px]" />
            </div>
          </div>
        </Modal>
      );
    }

    if (isAnyMobile) {
      return (
        <>
          <Modal
            className="p-0 w-[365px] h-fit overflow-hidden"
            closeButtonClassName="top-[12px] right-[12px]"
            isCloseOutside={!updateTicketModalHookState.hasFormChanges}
            onClickOutside={updateTicketModalHookState.HandleCloseModalWithConfirmation}
            isButtonClose={true}
            isOpen={updateTicketModalHookState.isUpdateTicketOpen}
            onClose={updateTicketModalHookState.HandleCloseModalWithConfirmation}
            lockBodyScroll
          >
            <MobileUpdateTicketForm {...updateTicketModalHookState} />
          </Modal>
          <TimeFrameModal
            submitText="Apply Date"
            title="Set Due date"
            initialDateRange={updateTicketModalHookState.dateValues ?? undefined}
            isOpen={updateTicketModalHookState.isOpenDateModal}
            onClose={() => {
              updateTicketModalHookState.handleCloseDateModal();
            }}
            onApply={(dateRange) => {
              updateTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
              updateTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
              updateTicketModalHookState.handleSetDateValuesModal(dateRange);
              updateTicketModalHookState.handleCloseDateModal();
            }}
          />
          <ConfirmUnsavedChangesModal
            isOpen={updateTicketModalHookState.isConfirmModalOpen}
            onConfirm={updateTicketModalHookState.handleConfirmDiscard}
            onCancel={updateTicketModalHookState.handleCloseConfirmModal}
          />
        </>
      );
    }

    return (
      <>
        <Modal
          className="p-0 max-w-[1080px] w-full h-fit overflow-hidden gap-0"
          isCloseOutside={!updateTicketModalHookState.hasFormChanges}
          onClickOutside={updateTicketModalHookState.HandleCloseModalWithConfirmation}
          isButtonClose={true}
          isOpen={updateTicketModalHookState.isUpdateTicketOpen}
          onClose={updateTicketModalHookState.HandleCloseModalWithConfirmation}
          closeButtonClassName="top-[12px] right-[12px]"
          lockBodyScroll
        >
          <DekstopUpdateTicketForm {...updateTicketModalHookState} />
        </Modal>
        <TimeFrameModal
          submitText="Apply Date"
          title="Set Due date"
          initialDateRange={updateTicketModalHookState.dateValues ?? undefined}
          isOpen={updateTicketModalHookState.isOpenDateModal}
          onClose={() => {
            updateTicketModalHookState.handleCloseDateModal();
          }}
          onApply={(dateRange) => {
            updateTicketModalHookState.form.setValue('startDate', dateRange?.from?.toISOString());
            updateTicketModalHookState.form.setValue('endDate', dateRange?.to?.toISOString());
            updateTicketModalHookState.handleSetDateValuesModal(dateRange);
            updateTicketModalHookState.handleCloseDateModal();
          }}
        />
        <ConfirmUnsavedChangesModal
          isOpen={updateTicketModalHookState.isConfirmModalOpen}
          onConfirm={updateTicketModalHookState.handleConfirmDiscard}
          onCancel={updateTicketModalHookState.handleCloseConfirmModal}
        />
      </>
    );
  }
);

UpdateTicketModal.displayName = 'UpdateTicketModal';
export default UpdateTicketModal;
